import { useMemo, type CSSProperties } from "react";

/** Voile féérique : halos de bokeh qui dérivent + fines étincelles qui scintillent. */
export function FaeriBackdrop() {
  const blobs = useMemo(
    () =>
      Array.from({ length: 7 }, (_, i) => ({
        id: i,
        size: 18 + Math.random() * 26, // vw
        top: Math.random() * 100,
        left: Math.random() * 100,
        dx: (Math.random() * 2 - 1) * 10,
        dy: (Math.random() * 2 - 1) * 8,
        dur: 16 + Math.random() * 16,
        delay: -Math.random() * 20,
      })),
    [],
  );
  const sparks = useMemo(
    () =>
      Array.from({ length: 40 }, (_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        dur: 2.5 + Math.random() * 4,
        delay: -Math.random() * 6,
        s: 2 + Math.random() * 3,
      })),
    [],
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* teinte thème par-dessus les photos */}
      <div
        className="absolute inset-0 mix-blend-soft-light"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 40%, transparent, var(--theme-primary) 160%)",
          opacity: 0.5,
        }}
      />
      {blobs.map((b) => (
        <span
          key={b.id}
          className="absolute rounded-full blur-3xl"
          style={
            {
              width: `${b.size}vw`,
              height: `${b.size}vw`,
              top: `${b.top}%`,
              left: `${b.left}%`,
              background: "var(--theme-accent)",
              opacity: 0.28,
              "--dx": `${b.dx}vw`,
              "--dy": `${b.dy}vh`,
              animation: `sv-drift ${b.dur}s ease-in-out ${b.delay}s infinite`,
            } as CSSProperties
          }
        />
      ))}
      {sparks.map((s) => (
        <span
          key={s.id}
          className="absolute rounded-full bg-white"
          style={{
            width: s.s,
            height: s.s,
            top: `${s.top}%`,
            left: `${s.left}%`,
            boxShadow: "0 0 8px 2px rgba(255,255,255,0.8)",
            animation: `sv-twinkle ${s.dur}s ease-in-out ${s.delay}s infinite`,
          }}
        />
      ))}
      {/* vignette */}
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(80% 80% at 50% 50%, transparent 55%, rgba(0,0,0,0.55))" }}
      />
    </div>
  );
}
